import {useState} from "react";
import {ChromePicker} from "react-color";
import styles from "./index.module.scss";
import {useGetStudioMode} from "components/Layout/hooks";

const ColorBoxInput = ({name, objectColor, colorOnChange, depth}) => {
  const [colorBoxOn, setColorBoxOn] = useState(false);
  const onClickColorBox = () => {
    setColorBoxOn(!colorBoxOn);
  };
  let title = "";
  if (
    name === "BackgroundColor" ||
    name === "FogColor" ||
    name === "SSAOColor" ||
    name === "GodraysColor" ||
    name === "LightColor" ||
    name === "GroundColor"
  )
    title = "Color";
  else title = name;

  const {isEditMode} = useGetStudioMode();
  return (
    <div className={`${styles.container} ${depth === 1 ? styles.depth_1 : ""}`}>
      <p className={styles.title}>{title}</p>
      <div className={styles.color_box} onClick={onClickColorBox} style={{background: objectColor}} />
      {colorBoxOn && isEditMode && (
        <div className={styles.color_picker}>
          <div onClick={onClickColorBox} className={styles.close_button} />
          <ChromePicker color={objectColor} onChange={e => colorOnChange(name, e)} />
        </div>
      )}
    </div>
  );
};

export default ColorBoxInput;
